import { useQuery } from '@tanstack/react-query'
import { fetchMyPartyInNation, partyKeys } from '@/services/parties'

export function useMyPartyInNation(nationId: string | undefined) {
  const partyQuery = useQuery({
    queryKey: partyKeys.myPartyInNation(nationId!),
    queryFn: () => fetchMyPartyInNation(nationId!),
    enabled: !!nationId,
  })

  return {
    party: partyQuery.data,
    isLoading: partyQuery.isLoading,
    error: partyQuery.error,
  }
}
